/** Marcador no ScaledContent — captureScreen neutraliza transform no clone html2canvas. */
export const SCALED_VIEWPORT_CONTENT_ATTR = 'data-efflux-scaled-viewport';

export function findScaledViewportContent(
  el: Element | null,
): HTMLElement | null {
  if (!el) return null;
  const scaled = el.closest(`[${SCALED_VIEWPORT_CONTENT_ATTR}]`);
  return scaled instanceof HTMLElement ? scaled : null;
}

/** Remove transform do viewport escalado no documento clonado do html2canvas. */
export function neutralizeScaledViewportInClone(doc: Document): void {
  const scaled = doc.querySelector(`[${SCALED_VIEWPORT_CONTENT_ATTR}]`);
  if (!(scaled instanceof HTMLElement)) return;

  const wrapper = scaled.parentElement;
  if (wrapper instanceof HTMLElement) {
    wrapper.style.display = 'block';
    wrapper.style.width = `${scaled.offsetWidth}px`;
    wrapper.style.height = `${scaled.offsetHeight}px`;
    wrapper.style.overflow = 'visible';
    wrapper.style.alignItems = 'unset';
    wrapper.style.justifyContent = 'unset';
  }

  scaled.style.transform = 'none';
}
